import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/heloc-calculator',
  component: () => import('../../routes/HelocCalculator.svelte'),
  card: {
    id: 'heloc-calculator',
    title: 'HELOC Calculator',
    description:
      'Calculate your Home Equity Line of Credit (HELOC) — credit available, total interest, and year-by-year repayment schedule.',
    icon: 'home',
    iconBgClass: 'bg-cyan-50',
    iconTextClass: 'text-cyan-600',
    href: '/heloc-calculator',
    category: 'Loans & Debt',
  },
  seo: {
    title: 'HELOC (Home Equity Line of Credit) Calculator – Credit & Repayment',
    description:
      'Free HELOC calculator to find credit available, total interest charged, and monthly repayment schedule for your home equity line of credit.',
  },
};

export default meta;